export const dashboardTutorialSteps = [
      {
        target: '#company-header',
        title: 'Cabecera de la empresa',
        content: 'Acá ves en qué empresa estás trabajando, qué módulo tenés abierto y los accesos principales para moverte rápido sin perder contexto.',
        narration: 'Acá ves en qué empresa estás trabajando, qué módulo tenés abierto y los accesos principales para moverte rápido sin perder contexto.',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '#dashboard-summary',
        title: 'Resumen general',
        content: 'Este es el punto de arranque. Desde acá ves la Base de datos para entrar a clientes, proveedores y registros operativos, además de leer en segundos cómo viene la operación del día.',
        narration: 'Este es el punto de arranque. Desde acá ves la Base de datos para entrar a clientes, proveedores y registros operativos, además de leer en segundos cómo viene la operación del día.',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '#recent-activity',
        title: 'Actividad reciente',
        content: 'Acá aparecen los últimos movimientos de rutas, servicios, stock y controles para que veas qué pasó recién y dónde conviene entrar.',
        narration: 'Acá aparecen los últimos movimientos de rutas, servicios, stock y controles para que veas qué pasó recién y dónde conviene entrar.',
        placement: 'top',
        disableBeacon: true,
      },
      {
        target: '#operation-status',
        title: 'Estado de la operación',
        content: 'Este bloque te dice si hoy hay rutas activas, movimientos pendientes y herramientas listas para trabajar sin tener que abrir cada módulo.',
        narration: 'Este bloque te dice si hoy hay rutas activas, movimientos pendientes y herramientas listas para trabajar sin tener que abrir cada módulo.',
        placement: 'left',
        disableBeacon: true,
      },
      {
        target: '#module-cards',
        title: 'Accesos principales',
        content: 'Estas tarjetas abren los siete módulos principales de G-CENTRA, en este orden: Logística, Servicio, Monitor en tiempo real, Reportes y liquidación, Gastos de Flota, Stock y movimientos, y Guía y soporte.',
        narration: 'Estas tarjetas abren los siete módulos principales de G-CENTRA, en este orden: Logística, Servicio, Monitor en tiempo real, Reportes y liquidación, Gastos de Flota, Stock y movimientos, y Guía y soporte.',
        placement: 'top',
        disableBeacon: true,
      },
];

export default dashboardTutorialSteps;
